/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonTokenDetailInfo } from '../models/BabylonTokenDetailInfo';
import type { BabylonTokenDetailRequest } from '../models/BabylonTokenDetailRequest';
import type { BabylonTokenItemHolderListInfo } from '../models/BabylonTokenItemHolderListInfo';
import type { BabylonTokenListInfo } from '../models/BabylonTokenListInfo';
import type { BabylonTokenListRequest } from '../models/BabylonTokenListRequest';
import type { BabylonTokenRequest } from '../models/BabylonTokenRequest';
import type { BabylonTokenTransferListInfo } from '../models/BabylonTokenTransferListInfo';
import type { BabylonTokenTransferListRequest } from '../models/BabylonTokenTransferListRequest';
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';
import type { EvmErc1155TokenInventoryListCountRequest } from '../models/EvmErc1155TokenInventoryListCountRequest';
import type { EvmErc1155TokenProfileRequest } from '../models/EvmErc1155TokenProfileRequest';
import type { EvmErc20TransferListInfo } from '../models/EvmErc20TransferListInfo';
import type { EvmErc721TokenInventoryListCountRequest } from '../models/EvmErc721TokenInventoryListCountRequest';
import type { EvmErc721TokenItemHolderRequest } from '../models/EvmErc721TokenItemHolderRequest';
import type { EvmErc721TokenItemProfileRequest } from '../models/EvmErc721TokenItemProfileRequest';
import type { EvmItemActivityListInfo } from '../models/EvmItemActivityListInfo';
import type { EvmTokenCardListInfo } from '../models/EvmTokenCardListInfo';
import type { EvmTokenDetailInfo } from '../models/EvmTokenDetailInfo';
import type { EvmTokenDetailRequest } from '../models/EvmTokenDetailRequest';
import type { EvmTokenHolderListInfo } from '../models/EvmTokenHolderListInfo';
import type { EvmTokenInfo } from '../models/EvmTokenInfo';
import type { EvmTokenInfoRequest } from '../models/EvmTokenInfoRequest';
import type { EvmTokenInventoryCountInfo } from '../models/EvmTokenInventoryCountInfo';
import type { EvmTokenInventoryListInfo } from '../models/EvmTokenInventoryListInfo';
import type { EvmTokenItemHolderInfo } from '../models/EvmTokenItemHolderInfo';
import type { EvmTokenItemHolderListInfo } from '../models/EvmTokenItemHolderListInfo';
import type { EvmTokenItemProfileInfo } from '../models/EvmTokenItemProfileInfo';
import type { EvmTokenItemRequest } from '../models/EvmTokenItemRequest';
import type { EvmTokenOwnerHistoryListInfo } from '../models/EvmTokenOwnerHistoryListInfo';
import type { EvmTokenRequest } from '../models/EvmTokenRequest';
import type { EvmTokenTransferListInfo } from '../models/EvmTokenTransferListInfo';
import type { HumanityTokenHolderListRequest } from '../models/HumanityTokenHolderListRequest';
import type { HumanityTokenItemHolderListInfo } from '../models/HumanityTokenItemHolderListInfo';
import type { HumanityTokenListInfo } from '../models/HumanityTokenListInfo';
import type { HumanityTokenListRequest } from '../models/HumanityTokenListRequest';
import type { HumanityTokenTransferListInfo } from '../models/HumanityTokenTransferListInfo';
import type { HumanityTokenTransferListRequest } from '../models/HumanityTokenTransferListRequest';
import type { KiteTokenContractTransferListInfo } from '../models/KiteTokenContractTransferListInfo';
import type { KiteTokenContractTransferRequest } from '../models/KiteTokenContractTransferRequest';
import type { KiteTokenDetailInfo } from '../models/KiteTokenDetailInfo';
import type { KiteTokenDetailRequest } from '../models/KiteTokenDetailRequest';
import type { KiteTokenHolderListInfo } from '../models/KiteTokenHolderListInfo';
import type { KiteTokenHolderListRequest } from '../models/KiteTokenHolderListRequest';
import type { KiteTokenTransferListInfo } from '../models/KiteTokenTransferListInfo';
import type { KiteTokenTransferListRequest } from '../models/KiteTokenTransferListRequest';
import type { SomniaNftItemProfileInfo } from '../models/SomniaNftItemProfileInfo';
import type { SomniaTokenDetailInfo } from '../models/SomniaTokenDetailInfo';
import type { SomniaTokenDetailRequest } from '../models/SomniaTokenDetailRequest';
import type { SomniaTokenHolderListInfo } from '../models/SomniaTokenHolderListInfo';
import type { SomniaTokenHolderListRequest } from '../models/SomniaTokenHolderListRequest';
import type { SomniaTokenInventoryListInfo } from '../models/SomniaTokenInventoryListInfo';
import type { SomniaTokenInventoryListRequest } from '../models/SomniaTokenInventoryListRequest';
import type { SomniaTokenListInfo } from '../models/SomniaTokenListInfo';
import type { SomniaTokenListRequest } from '../models/SomniaTokenListRequest';
import type { SomniaTokenTransferListInfo } from '../models/SomniaTokenTransferListInfo';
import type { SomniaTokenTransferListRequest } from '../models/SomniaTokenTransferListRequest';
import type { ZerogTokenDetailInfo } from '../models/ZerogTokenDetailInfo';
import type { ZerogTokenDetailRequest } from '../models/ZerogTokenDetailRequest';
import type { ZerogTokenHolderListInfo } from '../models/ZerogTokenHolderListInfo';
import type { ZerogTokenHolderListRequest } from '../models/ZerogTokenHolderListRequest';
import type { ZerogTokenInventoryListInfo } from '../models/ZerogTokenInventoryListInfo';
import type { ZerogTokenInventoryListRequest } from '../models/ZerogTokenInventoryListRequest';
import type { ZerogTokenListInfo } from '../models/ZerogTokenListInfo';
import type { ZerogTokenListRequest } from '../models/ZerogTokenListRequest';
import type { ZerogTokenTransferListInfo } from '../models/ZerogTokenTransferListInfo';
import type { ZerogTokenTransferListRequest } from '../models/ZerogTokenTransferListRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TokenControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenDetail({
        requestBody,
    }: {
        requestBody: (EvmTokenDetailRequest | BabylonTokenDetailRequest | ZerogTokenDetailRequest | KiteTokenDetailRequest | SomniaTokenDetailRequest),
    }): CancelablePromise<(EvmTokenDetailInfo | BabylonTokenDetailInfo | ZerogTokenDetailInfo | KiteTokenDetailInfo | SomniaTokenDetailInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenTransferList1({
        requestBody,
    }: {
        requestBody: (BabylonTokenTransferListRequest | HumanityTokenTransferListRequest | KiteTokenTransferListRequest | ZerogTokenTransferListRequest | SomniaTokenTransferListRequest),
    }): CancelablePromise<(BabylonTokenTransferListInfo | HumanityTokenTransferListInfo | KiteTokenTransferListInfo | ZerogTokenTransferListInfo | SomniaTokenTransferListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/transfer/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenList({
        requestBody,
    }: {
        requestBody: (BabylonTokenListRequest | HumanityTokenListRequest | ZerogTokenListRequest | SomniaTokenListRequest),
    }): CancelablePromise<(BabylonTokenListInfo | HumanityTokenListInfo | ZerogTokenListInfo | SomniaTokenListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenInventoryList({
        requestBody,
    }: {
        requestBody: (ZerogTokenInventoryListRequest | SomniaTokenInventoryListRequest),
    }): CancelablePromise<(ZerogTokenInventoryListInfo | SomniaTokenInventoryListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/inventory/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenInfo({
        requestBody,
    }: {
        requestBody: EvmTokenInfoRequest,
    }): CancelablePromise<EvmTokenInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/info',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenHolderList({
        requestBody,
    }: {
        requestBody: (BabylonTokenRequest | HumanityTokenHolderListRequest | ZerogTokenHolderListRequest | KiteTokenHolderListRequest | SomniaTokenHolderListRequest),
    }): CancelablePromise<(BabylonTokenItemHolderListInfo | HumanityTokenItemHolderListInfo | ZerogTokenHolderListInfo | KiteTokenHolderListInfo | SomniaTokenHolderListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/holder/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc721TokenTransferList({
        requestBody,
    }: {
        requestBody: EvmTokenRequest,
    }): CancelablePromise<EvmTokenTransferListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc721/transfer/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc721ItemProfile({
        requestBody,
    }: {
        requestBody: EvmErc721TokenItemProfileRequest,
    }): CancelablePromise<(EvmTokenItemProfileInfo | SomniaNftItemProfileInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc721/item/profile',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc721ItemHolder({
        requestBody,
    }: {
        requestBody: EvmErc721TokenItemHolderRequest,
    }): CancelablePromise<EvmTokenItemHolderInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc721/item/holder',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc721ItemHolderHistoryList({
        requestBody,
    }: {
        requestBody: EvmTokenItemRequest,
    }): CancelablePromise<(EvmTokenOwnerHistoryListInfo | SomniaTokenTransferListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc721/item/holder/history/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc721ItemActivityList({
        requestBody,
    }: {
        requestBody: EvmTokenItemRequest,
    }): CancelablePromise<(EvmItemActivityListInfo | SomniaTokenTransferListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc721/item/activity/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc721TokenInventoryList({
        requestBody,
    }: {
        requestBody: EvmTokenRequest,
    }): CancelablePromise<EvmTokenInventoryListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc721/inventory/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc721TokenInventoryListCount({
        requestBody,
    }: {
        requestBody: EvmErc721TokenInventoryListCountRequest,
    }): CancelablePromise<EvmTokenInventoryCountInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc721/inventory/list/count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc721TokenHolderList({
        requestBody,
    }: {
        requestBody: EvmTokenRequest,
    }): CancelablePromise<EvmTokenHolderListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc721/holder/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc20TokenTransferList({
        requestBody,
    }: {
        requestBody: EvmTokenRequest,
    }): CancelablePromise<EvmErc20TransferListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc20/transfer/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc20TokenHolderList({
        requestBody,
    }: {
        requestBody: EvmTokenRequest,
    }): CancelablePromise<EvmTokenHolderListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc20/holder/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc1155TokenTransferList({
        requestBody,
    }: {
        requestBody: EvmTokenRequest,
    }): CancelablePromise<EvmTokenTransferListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc1155/transfer/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc1155ItemProfile({
        requestBody,
    }: {
        requestBody: EvmErc1155TokenProfileRequest,
    }): CancelablePromise<(EvmTokenItemProfileInfo | SomniaNftItemProfileInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc1155/item/profile',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc1155ItemHolderList({
        requestBody,
    }: {
        requestBody: EvmTokenItemRequest,
    }): CancelablePromise<(EvmTokenItemHolderListInfo | SomniaTokenHolderListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc1155/item/holder/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc1155ItemHolderHistoryList({
        requestBody,
    }: {
        requestBody: EvmTokenItemRequest,
    }): CancelablePromise<EvmTokenOwnerHistoryListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc1155/item/holder/history/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc1155ItemActivityList({
        requestBody,
    }: {
        requestBody: EvmTokenItemRequest,
    }): CancelablePromise<(EvmItemActivityListInfo | SomniaTokenTransferListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc1155/item/activity/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc1155TokenInventoryList({
        requestBody,
    }: {
        requestBody: (EvmTokenRequest | ZerogTokenListRequest),
    }): CancelablePromise<(EvmTokenInventoryListInfo | ZerogTokenInventoryListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc1155/inventory/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc1155InventoryListCount({
        requestBody,
    }: {
        requestBody: EvmErc1155TokenInventoryListCountRequest,
    }): CancelablePromise<EvmTokenInventoryCountInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc1155/inventory/list/count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc1155TokenHolderList({
        requestBody,
    }: {
        requestBody: (EvmTokenRequest | ZerogTokenHolderListRequest),
    }): CancelablePromise<EvmTokenHolderListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/erc1155/holder/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenContractTransferList({
        requestBody,
    }: {
        requestBody: KiteTokenContractTransferRequest,
    }): CancelablePromise<KiteTokenContractTransferListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/contract/transfer/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenCardList({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<EvmTokenCardListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/card/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
